import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { deleteStockAlert } from 'src/features'
import { DeleteOutlined } from '@ant-design/icons'

const StockAlertActionsColumn = ({ stockAlertId }: { stockAlertId: number}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const handleDelete = () => { dispatch(deleteStockAlert(stockAlertId)) }

  return (
    <>
      <Popconfirm
        title={t('general.SureDelete')}
        onConfirm={handleDelete}
        okText={t('general.Yes')}
        cancelText={t('general.Cancel')}
      >
        <Button
          danger
          size='middle'
          shape='circle'
          className='radius-100'
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    </>
  )
}

export default StockAlertActionsColumn
